import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';
import { urlWithParams } from '../CommonUtils/urlWithParams';

export const RECEIVE_DATA = 'ASSUMPTIONS.RECEIVE_DATA';
export const INITIALIZE_SECTION = 'ASSUMPTIONS.INITIALIZE_SECTION';
export const RESET_SECTION = 'ASSUMPTIONS.RESET_SECTION';

export const initializeSection = (clientId, isAdviserArea) => ({
  type: INITIALIZE_SECTION,
  clientId,
  isAdviserArea,
});

export const resetSection = () => ({
  type: RESET_SECTION,
});

export const receiveData = (data, clientId) => ({
  type: RECEIVE_DATA,
  clientId,
  data,
});

export const requestData = clientId => async dispatch => {
  try {
    const response = await fetchWithDefaults(
      urlWithParams(
        `/${
          clientId ? 'Consumer' : 'Adviser'
        }/MarketDataAssumptions/GetMarketDataAssumptionsSummary`,
        clientId ? { clientId } : undefined,
      ),
    );

    const {
      payload: { viewData },
    } = await response.json();

    dispatch(receiveData(viewData, clientId));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};
